var map = {
	"./ar.mjs": [
		75997,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ar_mjs"
	],
	"./bg.mjs": [
		84276,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_bg_mjs"
	],
	"./ca.mjs": [
		70808,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ca_mjs"
	],
	"./cs.mjs": [
		97189,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_cs_mjs"
	],
	"./da.mjs": [
		1410,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_da_mjs"
	],
	"./de.mjs": [
		60629,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_de_mjs"
	],
	"./en-gb.mjs": [
		17777,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_en-gb_mjs"
	],
	"./es-do.mjs": [
		73381,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_es-do_mjs"
	],
	"./es-pr.mjs": [
		12849,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_es-pr_mjs"
	],
	"./es-us.mjs": [
		62358,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_es-us_mjs"
	],
	"./es.mjs": [
		47316,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_es_mjs"
	],
	"./et.mjs": [
		32052,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_et_mjs"
	],
	"./fi.mjs": [
		38949,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_fi_mjs"
	],
	"./fr.mjs": [
		12645,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_fr_mjs"
	],
	"./gl.mjs": [
		25810,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_gl_mjs"
	],
	"./he.mjs": [
		11433,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_he_mjs"
	],
	"./hi.mjs": [
		41456,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_hi_mjs"
	],
	"./hr.mjs": [
		50035,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_hr_mjs"
	],
	"./hu.mjs": [
		42344,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_hu_mjs"
	],
	"./id.mjs": [
		15455,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_id_mjs"
	],
	"./it.mjs": [
		89757,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_it_mjs"
	],
	"./ja.mjs": [
		62343,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ja_mjs"
	],
	"./ka.mjs": [
		37896,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ka_mjs"
	],
	"./kk.mjs": [
		54016,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_kk_mjs"
	],
	"./ko.mjs": [
		68594,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ko_mjs"
	],
	"./lt.mjs": [
		56171,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_lt_mjs"
	],
	"./lv.mjs": [
		46154,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_lv_mjs"
	],
	"./mn.mjs": [
		95661,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_mn_mjs"
	],
	"./nb.mjs": [
		79428,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_nb_mjs"
	],
	"./nl-be.mjs": [
		79771,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_nl-be_mjs"
	],
	"./nl.mjs": [
		99372,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_nl_mjs"
	],
	"./pl.mjs": [
		58605,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_pl_mjs"
	],
	"./pt-br.mjs": [
		59094,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_pt-br_mjs"
	],
	"./ro.mjs": [
		37685,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ro_mjs"
	],
	"./ru.mjs": [
		82083,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_ru_mjs"
	],
	"./sk.mjs": [
		85668,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_sk_mjs"
	],
	"./sl.mjs": [
		84239,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_sl_mjs"
	],
	"./sq.mjs": [
		31577,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_sq_mjs"
	],
	"./sv.mjs": [
		72366,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_sv_mjs"
	],
	"./th-be.mjs": [
		73281,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_th-be_mjs"
	],
	"./th.mjs": [
		46816,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_th_mjs"
	],
	"./tr.mjs": [
		46742,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_tr_mjs"
	],
	"./uk.mjs": [
		28117,
		"default-node_modules_ngx-bootstrap_chronos_esm2022_locale_locales_mjs-node_modules_ngx-bootst-14f0a6",
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_uk_mjs"
	],
	"./vi.mjs": [
		30891,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_vi_mjs"
	],
	"./zh-cn.mjs": [
		77677,
		"node_modules_ngx-bootstrap_chronos_esm2022_i18n_zh-cn_mjs"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 24418;
module.exports = webpackAsyncContext;